
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import api from "@/api";

@Component
export default class AbSelect extends Vue {
  val: any = "";

  created() {}

  // 传给后台的值
  // value 有可能是 undefined unll 不定义type
  @Prop() public value!: any;

  // 页面上显示的值
  @Prop({ required: true }) itemValue!: string;

  // 传给后台的值再数据中的属性
  @Prop({ required: true }) itemKey!: string;
  @Watch("value")
  onValueChange(newVal: any, oldVal: any) {
    this.val = newVal;
  }

  get dropdownList() {
    return this.list.map(x => {
      return { label: x[this.itemValue!], value: x[this.itemKey!] };
    });
  }

  @Prop({ required: false }) name!: string | number;

  @Prop({ required: false }) placeholder!: string;

  // 数据数组
  @Prop({ required: true }) list!: any[];

  @Prop({ required: false }) itemImage!: string | undefined;

  @Prop({ required: false }) itemTime!: string | undefined;

  @Prop({ required: false, default: false }) disabled!: boolean;

  @Prop({ required: false }) color!: string | undefined;

  private bindChange(e: any) {
    console.log(e);
    this.val = e;
    this.$emit("input", e);
  }
}
